import Filter from'./NewsFilter';export default Filter;